

    import { defineComponent, SetupContext, ref, PropType, computed, watch } from 'vue'
    import useStore from '@/hooks/useStore'
    import { Reply } from '@/types/message'

    export default defineComponent({
        emits: ['onClickReply'],
        props: {
            modelValue: {
                type: Object as PropType<Reply>,
                default: () => ({})
            }
        },
        setup (props, { emit }: SetupContext) {
            const store = useStore()
            const color = store.data.bgColor
            const state = ref<Reply>(props.modelValue)
            const getUserName = computed(() => state.value.type !== 'received' ? 'Você' : 'Atendente')

            watch(() => props.modelValue, (newValue) => {
                state.value = newValue
            })

            function anchorReply (): void {
                if (state.value?.message_id) {
                    emit('onClickReply', state.value.message_id)
                }
            }

            return {
                emit,
                anchorReply,
                getUserName,
                color,
                state
            }
        }
    })
